import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

//leave add
export const addLeaveData = createAsyncThunk(
  "leave/addleave",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/leaves", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//get leave list
export const getAllLeavelist = createAsyncThunk(
  "leave/getallleave",
  async (data, { rejectWithValue }) => {
    const {
      order_type,
      order_by,
      page_size,
      page,
      search_text,
      start_date,
      end_date,
      is_active,
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
      start_date,
      end_date,
      is_active,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/leaves?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//update leave data
export const updateLeave = createAsyncThunk(
  "leave/updatebeleave",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/leaves/${id}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//update leave status
export const updateleaveStatus = createAsyncThunk(
  "leave/updateleavestatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/leaves/${id}/status`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//delete leave
export const deleteleave = createAsyncThunk(
  "leave/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/leaves/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get single leave data
export const getLeaveById = createAsyncThunk(
  "leave/getSingle",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/leaves/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//leave duration options

export const getLeaveDuration = createAsyncThunk(
  "leave/duration",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/codebooks/${data.type}`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
